import { cva } from "class-variance-authority";

export const buttonVariants = cva(
  "inline-flex items-center justify-center gap-2 relative rounded-xs font-medium font-sans transition-colors focus-visible:outline-hidden focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50 disabled:saturate-0",
  {
    variants: {
      variant: {
        primary: "bg-primary text-primary-foreground hover:bg-primary/90",
        secondary:
          "bg-muted text-foreground hover:bg-muted/70 border border-border",
        outline:
          "border border-border bg-transparent text-foreground hover:bg-muted",
        ghost: "bg-transparent text-foreground hover:bg-muted",
        link: "text-primary underline-offset-4 hover:underline p-0! h-auto!",
        danger: "bg-danger text-danger-foreground hover:bg-danger/90",
        success: "bg-success text-success-foreground hover:bg-success/90",
        warning: "bg-warning text-warning-foreground hover:bg-warning/90",
        "outline-primary":
          "border border-primary bg-transparent text-primary hover:bg-primary-muted",
        "outline-danger":
          "border border-danger bg-danger-muted text-danger hover:bg-danger/20",
        "outline-success":
          "border border-success bg-success-muted text-success hover:bg-success/20",
        "outline-warning":
          "border border-warning bg-transparent text-warning hover:bg-warning-muted",
      },
      size: {
        xs: "h-7 px-2 text-xs",
        sm: "h-8 px-3 text-xs",
        default: "h-10 px-4 text-sm",
        lg: "h-11 px-8 text-base",
        icon: "h-9 w-9 p-0",
        "icon-xs": "h-6 w-6 p-0",
        "icon-sm": "h-8 w-8 p-0",
        "icon-lg": "h-11 w-11 p-0",
      },
    },
    defaultVariants: {
      variant: "primary",
      size: "default",
    },
  },
);
